/**
 * AI-Explain (data-ai-explain): Request Access catalog side drawers.
 * @see packages/eid-chatbot/explainUtils.ts
 */

export const CATALOG_DETAILS_AI_SECTION = 'details'

/**
 * Spread onto a wrapper around drawer body (desktop Drawer children, mobile details under the header).
 * @param {string} resourceLabel e.g. "application role", "shared folder"
 */
export function catalogDetailsDrawerExplainProps(resourceLabel) {
    return {
        'data-ai-explain-section': CATALOG_DETAILS_AI_SECTION,
        'data-ai-explain': `Request Access - ${resourceLabel} details: review attributes and tabs, then activate now or add to cart to request access.`,
    }
}

/** Spread onto ItemDetails.Tabs in catalog detail drawers */
export const catalogDetailsTabsExplainProps = {
    'data-ai-explain':
        'Details panel tabs: switch between overview, more information, and other sections for this item.',
}
